export default __webpack_public_path__ + "static/media/comingSoonThumbnailSerie.e67d00fe.jpg";